(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  (function() {
    const container = document.getElementById('sticky-atc-container');
    const stickyBar = document.getElementById('mobile-sticky-atc');
    const openBtn = document.querySelector('[data-open-sticky-atc]');
    const closeBtn = document.querySelector('[data-sticky-atc-close]');
    const backdrop = container && container.querySelector('.sticky-atc-container__backdrop');
    const qtyInput = container && container.querySelector('[data-sticky-qty-input]');
    const qtyDecrease = container && container.querySelector('[data-sticky-qty-decrease]');
    const qtyIncrease = container && container.querySelector('[data-sticky-qty-increase]');
    const panelAtcBtn = container && container.querySelector('[data-sticky-atc-submit]');
    const panelAtcLabel = container && container.querySelector('[data-sticky-atc-label]');
    const stickyBtnTextEl = stickyBar && stickyBar.querySelector('.mobile-sticky-atc__text');

    // BIS: hide disabled ATC button when .BIS_trigger is injected by AMP app
    function applyBisState() {
      const bisTrigger = document.querySelector('.BIS_trigger');
      if (!bisTrigger) return;

      // Hide the disabled sold-out ATC button on the product form
      const productForm = document.querySelector('[data-type="add-to-cart-form"]');
      if (productForm) {
        const disabledAtcBtn = productForm.querySelector('button[name="add"][disabled], button[name="add"].atc-button--sold-out');
        if (disabledAtcBtn) {
          disabledAtcBtn.style.display = 'none';
        }
      }

      // Update sticky bar for BIS
      if (stickyBar) {
        stickyBar.dataset.bisActive = '';
      }
      if (stickyBtnTextEl) {
        stickyBtnTextEl.textContent = window.Theme && window.Theme.translations && window.Theme.translations.notify_me
          ? window.Theme.translations.notify_me
          : 'Notify Me';
      }
      if (openBtn) {
        openBtn.removeAttribute('disabled');
        // Redirect sticky bar button click to BIS trigger
        openBtn.dataset.bisWired = 'true';
      }
    }

    // Run once on load in case AMP already injected
    applyBisState();

    // Watch for async injection
    const bisObserver = new MutationObserver(function() {
      if (document.querySelector('.BIS_trigger')) {
        applyBisState();
        bisObserver.disconnect();
      }
    });
    bisObserver.observe(document.body, { childList: true, subtree: true });

    // Intercept sticky bar click: if BIS-wired, delegate to BIS trigger instead of opening drawer
    if (openBtn) {
      openBtn.addEventListener('click', function(e) {
        if (openBtn.dataset.bisWired) {
          e.stopImmediatePropagation();
          const bisTrigger = document.querySelector('.BIS_trigger');
          if (bisTrigger) bisTrigger.click();
        }
      }, true); // capture phase so it runs before the openDrawer listener
    }

    if (!container || !openBtn) return;

    function openDrawer() {
      container.dataset.state = 'open';
      container.removeAttribute('aria-hidden');
    }

    function closeDrawer() {
      container.dataset.state = 'closed';
      container.setAttribute('aria-hidden', 'true');
    }

    openBtn.addEventListener('click', function() {
      openDrawer();
    });

    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (backdrop) backdrop.addEventListener('click', closeDrawer);

    if (qtyDecrease && qtyInput) {
      qtyDecrease.addEventListener('click', function() {
        const current = parseInt(qtyInput.value, 10) || 1;
        if (current > 1) qtyInput.value = current - 1;
      });
    }
    if (qtyIncrease && qtyInput) {
      qtyIncrease.addEventListener('click', function() {
        const current = parseInt(qtyInput.value, 10) || 1;
        qtyInput.value = current + 1;
      });
    }

    if (panelAtcBtn) {
      panelAtcBtn.addEventListener('click', function() {
        const mainForm = document.querySelector('[data-type="add-to-cart-form"]');
        if (!mainForm) return;

        const mainQtyInput = mainForm.querySelector('quantity-selector-component input') || mainForm.querySelector('input[name="quantity"]');
        if (mainQtyInput && qtyInput) {
          mainQtyInput.value = qtyInput.value;
        }

        const productFormComponent = mainForm.closest('product-form-component');
        if (productFormComponent) {
          mainForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          closeDrawer();
        }
      });
    }

    document.addEventListener('variant:update', function(e) {
      const variant = e.detail && (e.detail.resource || e.detail.variant);
      if (!variant) return;

      if (panelAtcLabel) {
        if (variant.available) {
          panelAtcLabel.textContent = window.Theme && window.Theme.translations && window.Theme.translations.add_to_cart
            ? window.Theme.translations.add_to_cart
            : 'Add to cart';
        } else {
          panelAtcLabel.textContent = window.Theme && window.Theme.translations && window.Theme.translations.sold_out
            ? window.Theme.translations.sold_out
            : 'Sold out';
        }
      }

      if (stickyBtnTextEl && stickyBar) {
        if ('bisActive' in stickyBar.dataset) {
          stickyBtnTextEl.textContent = window.Theme && window.Theme.translations && window.Theme.translations.notify_me
            ? window.Theme.translations.notify_me
            : 'Notify Me';
        } else if (variant.available) {
          stickyBtnTextEl.textContent = window.Theme && window.Theme.translations && window.Theme.translations.add_to_cart
            ? window.Theme.translations.add_to_cart
            : 'Add to cart';
        } else {
          stickyBtnTextEl.textContent = window.Theme && window.Theme.translations && window.Theme.translations.sold_out
            ? window.Theme.translations.sold_out
            : 'Sold out';
        }
      }

      // Re-evaluate BIS state after variant switch (async injection may have already happened)
      applyBisState();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
